import { TranslationsTypes } from '@/lib/i18n/i18n.client';

import {
  TRIAL_TIMEOUT_MS,
} from '@/blocks/ScrapingHero/constants';
import {
  ScrapingHeroAction,
  ScrapingHeroResponse,
} from '@/blocks/ScrapingHero/types';

import { demoDelayMs, getPreScrapedPayload } from './demo-responses';
import { extractScrapeJobError } from './extract-scrape-job-error';

const SCRAPER_TRIAL_API_URL = 'https://data.decodo.com/v1/trial';

export function scrape(
  targetUrl: string,
  activeTab: ScrapingHeroAction,
  texts: TranslationsTypes
): Promise<ScrapingHeroResponse> {
  return runScrape(targetUrl, activeTab, texts);
}

async function runScrape(
  targetUrl: string,
  activeTab: ScrapingHeroAction,
  texts: TranslationsTypes
): Promise<ScrapingHeroResponse> {
  const demoPayload = getPreScrapedPayload(activeTab, targetUrl);
  if (demoPayload) {
    await new Promise((resolve) => setTimeout(resolve, demoDelayMs()));
    return { url: targetUrl, payload: demoPayload };
  }

  const body =
    activeTab === 'search' ? { query: targetUrl } : { url: targetUrl };

  let response: Response;
  try {
    response = await fetch(`${SCRAPER_TRIAL_API_URL}/${activeTab}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
      signal: AbortSignal.timeout(TRIAL_TIMEOUT_MS),
    });
  } catch {
    throw new Error(texts.scraping_hero.request_failed);
  }

  const responseText = await response.text();

  if (!response.ok) {
    const { message } = extractScrapeJobError(
      responseText,
      response.statusText
    );
    throw new Error(message || texts.scraping_hero.request_failed);
  }

  try {
    return {
      url: targetUrl,
      payload: JSON.parse(responseText),
    };
  } catch {
    throw new Error(texts.scraping_hero.request_failed);
  }
}
